import { render } from "./CreateFilterSetsModal.vue?vue&type=template&id=81504f94&scoped=true"
import script from "./CreateFilterSetsModal.vue?vue&type=script&lang=js"
export * from "./CreateFilterSetsModal.vue?vue&type=script&lang=js"

import "./CreateFilterSetsModal.vue?vue&type=style&index=0&id=81504f94&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81504f94"]])

export default __exports__
import QCardSection from 'quasar/src/components/card/QCardSection.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCardSection});qInstall(script, 'directives', {ClosePopup});
